import { FEATURES, MODULES } from '../../constants/template-info'
import { PageContextSS } from '../../domains/PageContextSS'
import { ANALYTIC_COOKIES } from '../constants'
import { getFromSessionStorageWithExpiry } from '../getFromSessionStorageWithExpiry'
import isBrowser from '../isBrowser'
import { captureException } from '../sentryUtil'

export const getPageContextDetails = (): {
  currentPage: {
    page_name?: string
    page_type?: string
    page_path?: string
    page_variant?: string
  }
  previousPage: {
    page_name?: string
    page_type?: string
    page_path?: string
    page_variant?: string
  }
} => {
  try {
    if (isBrowser()) {
      const slugToPageContextMapFromSS = getFromSessionStorageWithExpiry(
        ANALYTIC_COOKIES.SLUG_TO_PAGE_CONTEXT_MAP_SESSION_STORAGE_KEY,
      )
      const parsedSlugToPageContextMapFromSS: Record<string, PageContextSS> = slugToPageContextMapFromSS
        ? JSON.parse(slugToPageContextMapFromSS)
        : {}
      const currentSlug = getFromSessionStorageWithExpiry(ANALYTIC_COOKIES.CURRENT_PAGE_PATH)
      const previousSlug = getFromSessionStorageWithExpiry(ANALYTIC_COOKIES.PREVIOUS_PAGE_PATH)
      const currentPageContext = currentSlug ? parsedSlugToPageContextMapFromSS[currentSlug] || {} : {}
      const previousPageContext = previousSlug ? parsedSlugToPageContextMapFromSS[previousSlug] || {} : {}
      return {
        currentPage: {
          ...currentPageContext,
          page_path: currentSlug ?? undefined,
        },
        previousPage: {
          ...previousPageContext,
          page_path: previousSlug ?? undefined,
        },
      }
    }
  } catch (error) {
    captureException(error, {
      module: MODULES.PAGE_CONTEXT_SESSION_STORAGE,
      feature: FEATURES.GET_PAGE_CONTEXT,
    })
  }
  return {
    currentPage: {},
    previousPage: {},
  }
}
